const commonAndMisc = {
  errorMessage404: "Oi! Puslapis, kurio ieškote, neegzistuoja", // translated 
  errorContentUnavailable:
    "Oi! Turinio, kurio ieškote, nėra. Prašome susisiekti su mumis dėl problemos", // translated 
  backToHome: "Grįžti namo", // translated 
  information: "Informacija", // translated 
  additionalInformation: "Papildoma informacija", // translated 
  destinationPlaceholder: "Kur tu eini", // translated 
  aboutUs: "Apie mus", // translated 
  pleaseWait: "Prašau palauk...", // translated 
  featuredHotels: "Teminiai viešbučiai", // translated 
  topPackages: "Populiariausi paketai", // translated 
  topTours: "Populiariausios ekskursijos", // translated 
  traveller: "Keliautojas", // translated 
  reviews: "Atsiliepimai", // translated 
  home: "Namai", // translated 
  packages: "Paketai", // translated 
  experiences: "Patirtys", // translated 
  close: "Uždaryti", // translated 
  loadingMessage: "Palaukite, kol ieškosime geriausių galimų kainų", // translated 
  loadingMessageTheHotelCo:
    "Palaukite, kol ieškosime geriausių galimų kainų", // translated 
  loadingMessageSearchStrip:
    "Palaukite, kol ieškosime geriausių galimų kainų...", // translated 
  topCountriesToVisit: "Populiariausios lankytinos šalys", // translated 
  profile: "Profilis", // translated 
  reservations: "Rezervacijos", // translated 
  myBookings: "Mano užsakymai", // translated 
  address: "Adresas", // translated 
  firstName: "Pirmas vardas", // translated 
  lastName: "Pavardė", // translated 
  email: "El. paštas", // translated 
  login: "Prisijungti", // translated 
  logout: "Atsijungti", // translated 
  myProfile: "Mano profilis", // translated
  myChatRooms: "Mano pokalbiai", // translated 
  chatRoomsListEmpty: "Šiai paskyrai nėra pokalbių kambarių.", // translated 
  chatRoomsOpen: "Atidaryti", // translated 
  chatRoomsLastActivity: "Paskutinė veikla", // translated 
  chatRoomsUnread: "Neskaityta", // translated 
  chatRoomsBadgeQuotation: "Pasiūlymas", // translated 
  chatRoomsBadgeTripOffer: "Kelionės pasiūlymas", // translated 
  chatRoomsOpenQuotationAria: "Atidaryti pasiūlymo pokalbį: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Atidaryti kelionės pasiūlymo pokalbį: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Atidaryti pokalbį: {{name}}", // translated 
  quotationChatInvalidLink:
    "Neteisinga pokalbio nuoroda. Atidarykite pokalbį iš profilio ar pasiūlymų sąrašo arba naudokite tik vieną iš room_code ar room_uid.", // translated 
  quotationChatNoTripDetails: "pokalbiui kelionės informacija nepasiekiama.", // translated 
  chat: "Pokalbis",  // translated 
  myAccount: "Mano sąskaita", // translated 
  myPoints: "Mano taškai", // translated 
  verified: "Patvirtinta", // translated 
  unverified: "Nepatvirtinta", // translated 
  selectLanguage: "Pasirinkite kalbą", // translated 
  selectCurrency: "Pasirinkite valiutą", // translated 
  upgrade: "Patobulinti", // translated 
  membership: "Narystė", // translated 
  travelTrust: "Kelionių trestas", // translated 
  signInUp: "Prisijungti/Prisijungti", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "visame pasaulyje esantys viešbučiai ir kurortai nuostabiomis didmeninėmis kainomis", // translated 
  dashboard: "Prietaisų skydelis", // translated 
  pricing: "Kainodara", // translated 
  refundable: "Grąžinama", // translated 
  cars: "Automobiliai", // translated 
  cruises: "Kruizai", // translated 
  view: "Žiūrėti", // translated 
  price: "Kaina", // translated 
  totalPrice: "Bendra kaina", // translated 
  filterRoomName: "Filtruoti kambario pavadinimą", // translated 
  get: "Gauk", // translated 
  guestInformationValidation: "Svečių informacijos patvirtinimas", // translated 
  reservation: "Rezervacija", // translated 
  checkIn: "Įsiregistruoti", // translated 
  checkOut: "Išsiregistruokite", // translated 
  paymentInitiattionErroeMessage:
    "Nepavyko pradėti mokėjimo proceso. Atsiprašome už nepatogumus", // translated 
  warning: "Įspėjimas", // translated 
  couldNotFindPriceForDateWarning:
    "Negalėjome rasti kainos šiai datai. Bandykite dar kartą, kad pasirinktumėte kitą datą", // translated 
  searchFormValidationError: "Paieškos formos patvirtinimo klaida", // translated 
  pleaseSelectValidDateFirst: "Pirmiausia pasirinkite tinkamą datą", // translated 
  searchError: "Paieškos klaida", // translated 
  priceSearchInitiationError:
    "Nepavyko pradėti kainų paieškos proceso. Pabandykite dar kartą vėliau. Atsiprašome už nepatogumus", // translated 
  searchWarning: "Paieškos įspėjimas", // translated 
  couldNotFindPriceAndOrAvailability:
    "Nepavyko rasti kainos ir (arba) prieinamumo pagal jūsų užklausą. Atsiprašome už nepatogumus", // translated 
  joinNow: " Prisijunk dabar", // translated 
  signIn: "Prisijungti", // translated 
  searchNow: "Ieškokite dabar", // translated 
  bookingFailed: "Užsakymas nepavyko", // translated 
  sorryForTheInconvenience: "Atsiprašome už nepatogumus", // translated 
  contactUsToAssistWithYourBooking:
    "Susisiekite su mumis, kad padėtume atlikti užsakymą. Atsiprašome už nepatogumus", // translated 
  paymentFailedTryAgain: "Mokėjimas nepavyko. Prašau, pabandykite dar kartą", // translated 
  quickLinks: "Greitos nuorodos", // translated 
  tours: "Ekskursijos", // translated 
  termsAndConditions: "Taisyklės ir sąlygos", // translated 
  pleaseWaitWhileInitiatingPayment:
    "Palaukite, kol pradėsime mokėjimo procesą", // translated 
  back: "Atgal", // translated 
  nextStep: "Kitas žingsnis", // translated 
  book: "Knyga", // translated 
  checkout: "Patikra", // translated 
  specifyPickUpPoint: " Nurodykite pageidaujamą atsiėmimo vietą", // translated 
  pickupPoint: "Paėmimo taškas", // translated 
  optional: "neprivaloma", // translated 
  provideImportantInfoForYourTravel:
    "Praneškite mums bet kokią informaciją, kuri būtų svarbi jūsų kelionės metu", // translated 
  remarks: "Pastabos", // translated 
  travellerInformation: "Informacija keliautojams", // translated 
  bookingRemarks: "Užsakymo pastabos", // translated 
  bookingOverview: "Užsakymo apžvalga", // translated 
  paymentFailed: "Mokėjimas nepavyko", // translated 
  paymentSuccess: "Mokėjimo sėkmė", // translated 
  at: "Prie", // At date // translated  // translated 
  on: "Įjungta", // on date // translated 
  person: "asmuo", // translated 
  cancellationPolicy: "Atšaukimo politika", // translated 
  From: "Nuo", // translated 
  to: "Į", // translated 
  cancellationIs: "atšaukimas yra", // translated 
  pickup: "Paimti", // translated 
  flights: "Skrydžiai", // translated 
  Accommodation: "Apgyvendinimas", // translated 
  payAndBook: "Mokėti ir užsisakyti", // translated 
  onRequest: "Pageidaujant", // translated 
  weAreFindingTheBestAvailableServices:
    "Ieškome geriausių paslaugų", // translated 
  withTheBestAvailablePrices: "su geriausiomis prieinamomis kainomis", // translated 
  inRealTime: "realiu laiku", // translated 
  seconds: "sekundžių", // translated 
  thisProcessCanTakeUpToOneMinute: "Šis procesas gali užtrukti iki 1 minutės", // translated 
  pleaseDoNotRefreshThisPage: "Prašome neatnaujinti šio puslapio", // translated 
  wellItSeemsItCanTakeBitLonger: "Na... atrodo, kad tai gali užtrukti šiek tiek ilgiau", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "Jūsų naršyklė nepalaiko vaizdo įrašo žymos", // translated 
  bookingSuccess: "Užsakymo sėkmė", // translated 
  bookingReference: "Užsakymo nuoroda", // translated 
  referenceCopied: "Nuoroda nukopijuota", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "Netrukus gausite el. laišką, kuriame bus visa reikalinga rezervacijai reikalinga informacija", // translated 
  viewMore: "Peržiūrėti daugiau", // translated 
  readMore: "Skaityti daugiau", // translated 
  customerSupport: "Pagalba klientams", // translated 
  socialMedia: "Socialinė žiniasklaida", // translated 
  hours: "valandų", // translated 
  hour: "valandą", // translated 
  minutes: "minučių", // translated 
  minute: "minutė", // translated 
  memberId: "Vartotojo ID", // translated 
  star: "Žvaigždė", // translated 
  stars: "Žvaigždės", // translated 
  proceed: "Tęskite", // translated 
  clearAllFilters: "Išvalyti visus filtrus", // translated 
  clearYourFilters: "Norėdami peržiūrėti rezultatus, išvalykite filtro parinktis", // translated 
  noOptionsForSelectedFilters: "Nėra parinkčių, kaip suderinti filtrus", // translated 
  privacyPolicy: "Privatumo politika", // translated 
  security: "Saugumas", // translated 
  nearby: "Netoliese", // translated 
  distanceFromSelection: "Atstumas nuo pasirinkimo", // translated 
  km: "km", // translated 
  restaurants: "Restoranai", // translated 
  active: "Aktyvus", // translated 
  visitSite: "Apsilankykite svetainėje", // translated 
  score: "Rezultatas", // translated 
  applicationAvailable: "pasiekiama programa", // translated 
  sendUsEmail: "Atsiųskite mums el. laišką", // translated 
  sendUsYourRequest: "Atsiųskite mums savo prašymą", // translated 
  notAvailable: "Nepasiekiamas", // translated 
  found: "Rasta", // translated 
  progressAt: "Pažanga ties", // translated 
  currency: "Valiuta", // translated 
  sendUsRequest: "Atsiųskite mums savo prašymą", // translated 
  noReservationsForThisProduct: "Nėra jokių išlygų šiam produktui", // translated 
  noBookingsForThisProduct: "Nėra šio produkto užsakymų", // translated 
  confirmed: "Patvirtinta", // translated 
  cancelled: "Atšauktas", // translated 
  pending: "Kol", // translated 
  notConfirmed: "Nepatvirtintas", // translated 
  status: "Būsena", // translated 
  reference: "Nuoroda", // translated 
  leadGuest: "Pagrindinis svečias", // translated 
  sendVoucherEmail: "Siųsti kuponą el", // translated 
  sendCancellationEmail: "Siųsti atšaukimo el. laišką", // translated 
  downloadVoucher: "Atsisiųskite kuponą", // translated 
  emailHasBeenSent: "El. laiškas sėkmingai išsiųstas", // translated 
  emailNotSentTryAgain: "Laiškas neišsiųstas! Prašau, pabandykite dar kartą", // translated 
  titleIsRequired: "Pavadinimas būtinas", // translated 
  genderIsRequired: "Būtina nurodyti lytį", // translated 
  firstNameMustContainAlphabetic:
    "Vardą turi sudaryti tik abėcėliniai simboliai", // translated 
  firstNameIsRequired: "Vardas būtinas", // translated 
  lastNameIsRequired: "Būtina nurodyti pavardę", // translated 
  lastNameMustContainAlphabetic:
    "Pavardėje turi būti tik abėcėlės simboliai", // translated 
  phoneNumberInTheFormat: "Telefono numeris turi būti tokio formato, kuriame nėra tarpų", // translated 
  phoneNumberIsRequired: "Reikalingas telefono numeris", // translated 
  emailIsRequired: "Būtinas el", // translated 
  invalidEmail: "Neteisingas el. pašto adresas", // translated 
  addressIsRequired: "Adresas yra būtinas", // translated 
  cityIsRequired: "Reikalingas miestas", // translated 
  postalCodeIsRequired: "Būtinas pašto kodas", // translated 
  countryIsRequired: "Būtina nurodyti šalį", // translated 
  yourReservationIsInProgress: "Jūsų rezervacija vykdoma", // translated 
  clickHere: "Paspauskite čia", // translated 
  iHaveReadAgreeWithAbove: "Aš perskaičiau ir sutinku su tuo, kas išdėstyta aukščiau", // translated 
  pleaseCheckTheBox:
    "Prieš pereidami prie kito veiksmo, pažymėkite langelį, kad nurodytumėte, jog perskaitėte pateiktą informaciją ir su ja sutinkate.", // translated 
  ourContactNumbersAre: "Mūsų kontaktiniai numeriai yra", // translated 
  operationalHours: "Darbo valandos", // translated 
  monday: "Pirmadienis", // translated 
  tuesday: "antradienis", // translated 
  wednesday: "trečiadienį", // translated 
  thursday: "ketvirtadienis", // translated 
  friday: "penktadienis", // translated 
  saturday: "šeštadienis", // translated 
  sunday: "sekmadienis", // translated 
  monday_to_friday: "nuo pirmadienio iki penktadienio", // translated 
  closed: "Uždaryta", // translated 
  topUpPoints: "Papildyti taškus", // translated 
  gender: "Lytis", // translated 
  nationality: "Tautybė", // translated 
  maintenanceTitle: "Svetainė tvarka", // translated 
  maintenanceDescription:
    "Atliekame planinę priežiūrą. prašome netrukus.", // translated 
  maintenanceCountdownLabel: "Numatomas panašus į laiką", // translated 
  maintenanceLogoAlt: "Svetainės logotipas", // translated 
  maintenanceDays: "Dienos", // translated 
  maintenanceHours: "Valandos", // translated 
  maintenanceMinutes: "Minutės", // translated 
  maintenanceSeconds: "Sekundės", // translated 
  maintenanceStatusBadge: "Planuojama priežiūra", // translated 
  maintenanceRefresh: "Atnaujinti puslapį", // translated 
  maintenanceExpired:
    "Priežiūra netrukus turėtų būti baigta. Atnaujinkite puslapį.", // translated 
};



export default commonAndMisc;
